import { startLogin } from "../auth/oidc";
import { t } from "../i18n";

export function Login() {
  return (
    <div class="grid h-full place-items-center p-10">
      <div class="w-full max-w-sm rounded-lg border border-ink-300 bg-ink-100 p-8 shadow-panel">
        <div class="mb-6 flex items-center gap-3">
          <img src="/logo.png?v=2" width="32" height="32" alt="" aria-hidden="true" />
          <div>
            <div class="text-lg font-semibold">
              <span class="text-brand">med</span>
              <span class="text-white">pod</span>
            </div>
            <div class="text-xs uppercase tracking-wider text-ink-700">Endoscopy</div>
          </div>
        </div>
        <p class="mb-6 text-sm text-ink-800">
          {t("auth.intro")}
        </p>
        <button
          type="button"
          class="btn-primary w-full justify-center"
          onClick={() => startLogin().catch(console.error)}
        >
          {t("auth.signin")}
        </button>
      </div>
    </div>
  );
}
